// extracted by mini-css-extract-plugin
export default {"header":"Header_header__tQpOW","title":"Header_title__dzqEx"};